export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  OPERATIVO_RENIECYT = 'ROLE_OPERATIVO_RENIECYT',
  DIRECCION_RENIECYT = 'ROLE_DIRECCION_RENIECYT',
  OPERATIVO_CONSULTA_RENIECYT = 'ROLE_OPERATIVO_CONSULTA_RENIECYT',
  ROLE_REGISTRO_ANOTACIONES = 'ROLE_REGISTRO_ANOTACIONES',
}
